/* eslint-disable no-console */

export const userRegisterTealiumEvent = (store) => {
  try {
    window.utag.link({
      customer_address_city: store.city,
      customer_address_postal_code: store.zip,
      customer_address_state: store.state,
      customer_address_street: store.homeStreetAddress,
      customer_email: store.email,
      customer_first_name: store.firstName,
      customer_last_name: store.lastName,
      customer_phone_number: store.primaryPhoneNumber,
      monthly_income: store.grossMonthlyIncome,
      partner_id: window.AppConfig.partner.partner_id,
      tealium_event: 'user_register'
    });
  } catch (e) {
    console.log(e);
    window.Raven?.captureException('Tealium error', {
      extra: {
        error_message: e.message,
        method: 'userRegisterTealiumEvent'
      }
    });
  }
};
export const reduxApplicationParams = (eventName, store) => {
  const prepopped = window.AppConfig?.reg_field_vals || {};
  return {
    customer_address_city:
      store.city || prepopped['registration[location][city]'],
    customer_address_postal_code:
      store.zip || prepopped['registration[location][zip]'],
    customer_address_state:
      store.state || prepopped['registration[location][state]'],
    customer_address_street:
      store.homeStreetAddress || prepopped['registration[street_address]'],
    customer_email: store.email || prepopped['registration[email_address]'],
    customer_first_name:
      store.firstName || prepopped['registration[first_name]'],
    customer_last_name: store.lastName || prepopped['registration[last_name]'],
    customer_phone_number:
      store.primaryPhoneNumber || prepopped['registration[mobile_phone]'],
    monthly_income:
      store.grossMonthlyIncome ||
      prepopped['registration[gross_monthly_income]'],
    partner_id: window.AppConfig?.partner?.partner_id,
    tealium_event: eventName
  };
};

export const reduxApplicationTealiumEventListener = (store) => {
  try {
    window.sendTealiumEvent(() =>
      window.utag.view(reduxApplicationParams('loan_app', store))
    );
  } catch (e) {
    console.log(e);
    window.Raven?.captureException('Tealium error', {
      extra: {
        error_message: e.message,
        method: 'reduxApplicationTealiumEventListener'
      }
    });
  }
};
/* eslint-enable no-console */
